module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAeUlEQVR42u3aMQ0AIAxE0crBATP+NeCCkaQgolvfJd/Amy8yMzoXAAAAAAAAAAAAAAA0B/jLyu5epZ0xSwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6AXiKAgAAAAAAAAAAAADQqgfjhNmqJWf2EAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Belgium.png
// module id = G1/L
// module chunks = 0 62 63